__turbopack_context__.v({
  "body": "Settings-module__-O0OfW__body",
  "errors": "Settings-module__-O0OfW__errors",
  "panel": "Settings-module__-O0OfW__panel",
  "tabList": "Settings-module__-O0OfW__tabList",
  "tabs": "Settings-module__-O0OfW__tabs",
});
